import React from 'react';
import PersonForm from "./personForm";
import Paper from "@material-ui/core/Paper";
import { withStyles } from '@material-ui/core/styles';
import Snackbar from "@material-ui/core/Snackbar";
import Loading from "../loading/loading";
import CustomModal from "../elements/customModal";
import ChangePasswordForm from './changePasswordForm';

const styles = theme => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
  button: {
    margin: theme.spacing.unit,
  },
  list: {
    maxHeight: 50 * 2,
    overflowY: 'auto'
  },

});

const Person =  (props) =>{
  const { classes, loading, message, isPasswordModalOpen, changePersonState,  submitPassword,
    resetPasswordMessage, resettingPassword} = props;

  return (
    <Paper className={classes.root} elevation={4}>
      <CustomModal
        open={isPasswordModalOpen}
        handleClose={() => changePersonState({key:'isPasswordModalOpen', value: false})}
        content={
          <div>
            <Loading displayLoader={resettingPassword}/>
            <ChangePasswordForm
              {...props}
              handleCancel={() => changePersonState({key: 'isPasswordModalOpen', value: false})}
            />
          </div>
        }
      />
      <Loading displayLoader={loading}/>
      <div className={'row'}>
        <div className={'col-12 col-lg-4'}>
          <PersonForm
            {...props}
            initialValues={{
              ...props.person,
              roleId: props.person.roles && props.person.roles.length > 0? props.person.roles[0].id:''
            }}
            handleCancel={props.history.goBack}
          />
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!resetPasswordMessage}
        onClose={() => { props.changePersonState({key: 'resetPasswordMessage', value: ''}) }}
        ContentProps={{'aria-describedby': 'message-id',}}
        message={<span id="message-id">{resetPasswordMessage}</span>}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={!!message}
        onClose={() => { props.changePersonState({key: 'message', value: ''}) }}
        ContentProps={{'aria-describedby': 'message-id',}}
        message={<span id="message-id">{message}</span>}
      />
    </Paper>
  )

};

export default withStyles(styles)(Person);



// WEBPACK FOOTER //
// ./src/components/person/person.js